import React, { Suspense } from "react";
import ReactDOM from "react-dom/client";
import "./assets/styles/index.css";
import "./assets/styles/App.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import store from "stores";
import { LoadingFallback } from "components/common";
import { BrowserRouter } from "react-router-dom";
import { AuthContextProvider } from "stores/auth-context";
import NotificationToastListener from "components/common/Notification/NotificationToastListener";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <Suspense fallback={<LoadingFallback />}>
        <BrowserRouter basename={``}>
          <AuthContextProvider>
            <NotificationToastListener />
            <App />
          </AuthContextProvider>
        </BrowserRouter>
      </Suspense>
    </Provider>
  </React.StrictMode>
);

reportWebVitals();